import React from "react";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

function FormAlert(props) {
  const { severity, message, marginBtm } = props;
  const lightThemeTextColor = severity === `error` ? "#D50000" : undefined;
  return (
    <Alert
      role="status"
      aria-live="polite"
      tabIndex="0"
      severity={severity}
      elevation={2}
      sx={(theme) => ({
        marginBottom: marginBtm,
        "& .MuiAlert-icon": { display: "none" },
        ".MuiTypography-root": {
          color: theme.palette.mode === "light" ? lightThemeTextColor : "#fff",
          fontSize: "0.9rem",
          ...theme.applyStyles("light", { color: undefined }),
        },
        display: "flex",
        justifyContent: "center",
      })}
    >
      <Typography align="center">{message}</Typography>
    </Alert>
  );
}
FormAlert.propTypes = {
  severity: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  marginBtm: PropTypes.string,
};
FormAlert.defaultProps = {
  marginBtm: undefined,
};
export default FormAlert;
